var React = require('react');

function Divider2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,0 C16.6666667,66 33.3333333,99 50,99 C66.6666667,99 83.3333333,66 100,0 L100,100 L0,100 L0,0 Z"}));
}

Divider2.defaultProps = {"width":"100%","height":"96px","viewBox":"0 0 100 100","version":"1.1","preserveAspectRatio":"none"};

module.exports = Divider2;

Divider2.default = Divider2;
